export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9617.3492f362.jpg";